import { theme } from 'antd';
import type { ThemeConfig } from 'antd';

const { darkAlgorithm } = theme;

export const antdTheme: ThemeConfig = {
    algorithm: darkAlgorithm,
    token: {
        colorPrimary: '#53a9f3',
        colorInfo: '#53a9f3',
        colorBgBase: '#081321',
        colorBgContainer: '#0e2035',
        colorBgElevated: '#112c4f',
        colorBorder: 'rgba(83, 169, 243, 0.16)',
        colorText: '#f2f8fc',
        colorTextSecondary: '#91a8bb',
        colorTextPlaceholder: '#7290a8',
        borderRadius: 10,
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        controlHeight: 40,
    },
    components: {
        Layout: {
            siderBg: '#081321',
            headerBg: '#081321',
            bodyBg: '#081321',
        },
        Menu: {
            darkItemBg: 'transparent',
            darkSubMenuItemBg: 'transparent',
            darkItemColor: '#8ea7bd',
            darkItemHoverBg: '#102841',
            darkItemHoverColor: '#dce8f1',
            darkItemSelectedBg: '#173d67',
            darkItemSelectedColor: '#f2f8fc',
            itemBorderRadius: 12,
            itemMarginInline: 8,
            itemHeight: 42,
            iconSize: 16,
            activeBarBorderWidth: 0,
        },
        Input: {
            colorBgContainer: '#112c4f',
            activeBorderColor: '#53a9f3',
            hoverBorderColor: '#2f69b4',
            colorBorder: 'rgba(83, 169, 243, 0.16)',
            activeShadow: '0 0 0 2px rgba(83, 169, 243, 0.14)',
            addonBg: '#112c4f',
        },
        Breadcrumb: {
            itemColor: '#91a8bb',
            lastItemColor: '#f2f8fc',
            linkColor: '#91a8bb',
            linkHoverColor: '#53a9f3',
            separatorColor: '#7290a8',
        },
        Button: {
            primaryColor: '#081321',
            defaultBg: '#ffffff09',
            defaultBorderColor: '#34658f',
            defaultColor: '#dce8f1',
            borderRadius: 9,
            controlHeight: 44,
        },
        Checkbox: {
            colorPrimary: '#53a9f3',
            colorText: '#91a8bb',
        },
        Form: {
            labelColor: '#91a8bb',
        },
        Modal: {
            contentBg: '#0e2035',
            headerBg: '#0e2035',
            titleColor: '#f2f8fc',
            colorBgMask: 'rgba(3, 10, 20, 0.73)',
        },
    },
};
